module.exports = __webpack_public_path__ + "img/pay-method-c.2bf4eb06.svg";